import { Button } from "design-system/atoms/Button"
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useTranslation } from "react-i18next"

type Props = {
  errorMessage: string | null
  onReset: () => void
  onClose: () => void
  variant: "failed" | "notFound"
}

export function ImportFailedStep({ errorMessage, onReset, onClose, variant }: Props) {
  const { t } = useTranslation()
  const titleKey =
    variant === "notFound"
      ? "customers.imports.progress.notFound.title"
      : "customers.imports.progress.failed.title"
  const descriptionKey =
    variant === "notFound"
      ? "customers.imports.progress.notFound.description"
      : "customers.imports.progress.failed.description"
  const ctaKey =
    variant === "notFound"
      ? "customers.imports.progress.notFound.startOver"
      : "customers.imports.progress.failed.tryAgain"

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t(titleKey)}</DialogTitle>
        <DialogDescription>{t(descriptionKey)}</DialogDescription>
      </DialogHeader>
      {errorMessage && <span className="text-sm text-destructive py-2">{errorMessage}</span>}
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>
          {t("shared.close")}
        </Button>
        <Button onClick={onReset}>{t(ctaKey)}</Button>
      </DialogFooter>
    </>
  )
}
